import fetchWrapper from "./fetchWrapper";
import { FetchWrapperError } from "./types/errors/fetchWrapperError";

type validatedAddressReturnType = {
    street: string,
    city: string,
    state: string,
    postalCode: string,
    country: string,
    stateAbbr: string,
    formattedAddress: string,
    validated: boolean,
    hasChanged: boolean,
    changes?: []
}

export default async function validateAddress(addressObject: any): Promise<validatedAddressReturnType | FetchWrapperError> {
    const addressToValidate = {
        street: addressObject.address,
        city: addressObject.city,
        state: addressObject.state,
        postalCode: addressObject.postalCode,
        country: addressObject.country,
        houseNumber: addressObject.houseNumber,
        address2: addressObject.address2
    }

    const validationRequest: validatedAddressReturnType | FetchWrapperError = await fetchWrapper('/api/validateAddress', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(addressToValidate),
    });
    return validationRequest;
};
